import React from 'react';
import Banner from '../Components/Home/Banner';
import Ticker from '../Components/Ticker/Ticker';
import LatestNews from '../Components/Home/LatestNews';
import GamesQuiz from '../Components/Home/GamesQuiz';
import PartnerUpdates from '../Components/Home/PartnerUpdates';
import SaudiaCompetitions from '../Components/Home/SaudiaCompetitions';
import CTASection from '../Components/Home/CTASection';
import PartnerStreams from '../Components/Home/PartnerStreams';

function Home() {
  return (
    <>
      <Banner />

      <Ticker />

      <LatestNews />

      <GamesQuiz />

      <PartnerUpdates />

      <SaudiaCompetitions />

      <Ticker />

      {/* <CTASection /> */}

      <PartnerStreams />
    </>
  );
}

export default Home;
